<template>
    <v-dialog v-model="active" persistent max-width="50em">
        <v-card>
            <v-card-title class="justify-center">
              <h1>Informações do pedido</h1>
            </v-card-title>
            <v-card-text v-if="pedido">
                <v-layout justify-space-between wrap class="mb-2">
                    <v-flex xs5>
                      <b>ID do pedido:</b> #{{ pedido.id }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Código:</b> {{ pedido.status_entrega === 'entregue' ? pedido.codigo : 'Ainda não informado' }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Status da entrega:</b> {{ pedido.status_entrega }}
                    </v-flex>
                    <v-flex xs5>
                        <b>Data de realização:</b> {{ pedido.data | formatDate('DD/MM/YYYY') }}
                    </v-flex>
                    <v-flex xs5 v-if="pedido.data_entrega_prevista">
                        <b>Data prevista de entrega:</b> {{ pedido.data_entrega_prevista | formatDate('DD/MM/YYYY') }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Data de envio:</b>
                      <span v-if="pedido.data_envio">
                        {{ pedido.data_envio | formatDate('DD/MM/YYYY') }}
                      </span>
                      <span v-else>
                        Ainda não enviado
                      </span>
                    </v-flex>
                    <v-flex xs5>
                        <b>Data de entrega:</b>
                        <span v-if="pedido.data_entrega">
                          {{ pedido.data_entrega | formatDate('DD/MM/YYYY') }}
                        </span>
                        <span v-else>
                          Ainda não entregue
                        </span>
                    </v-flex>
                     <v-flex xs5>
                       <b>Vinculado a Assinatura:</b> {{ pedido.assinatura ? 'Sim' : 'Não' }}
                    </v-flex>
                    <v-flex xs5>
                       <b>Finalizado:</b> {{ pedido.finalizado ? 'Sim' : 'Não' }}
                    </v-flex>
                    <v-flex xs5>
                       <b>Taxa de entrega:</b> {{ pedido.taxa_entrega || 0 | currency({ fractionCount: 2 }) }}
                    </v-flex>
                    <v-flex xs5>
                       <b>Desconto:</b> {{ pedido.desconto || 0 | currency({ fractionCount: 2 }) }}
                    </v-flex>
                    <v-flex xs5>
                       <b>Subtotal:</b> {{ pedido.subtotal | currency({ fractionCount: 2 }) }}
                    </v-flex>
                    <v-flex xs12 v-if="pedido.endereco_entrega">
                       <b>Endereço de entrega:</b> {{ pedido.endereco_entrega.logradouro }}, {{ pedido.endereco_entrega.numero }}, {{ pedido.endereco_entrega.bairro }}, {{ pedido.endereco_entrega.cidade }}, CEP:  {{ pedido.endereco_entrega.cep }} - {{ pedido.endereco_entrega.estado }}
                    </v-flex>
                    <v-flex xs12>
                        <v-divider></v-divider>
                    </v-flex>
                    <template v-if="pedido.cliente">
                      <v-flex xs12 class="mb-2">
                        <h3 class="text-xs-center">Informações do cliente</h3>
                      </v-flex>
                      <v-flex xs5>
                          <b>Nome:</b> {{ pedido.cliente.nome }}
                      </v-flex>
                      <v-flex xs5>
                          <b>Telefone:</b> {{ pedido.cliente.telefone | formataTelefone }}
                      </v-flex>
                      <v-flex xs12 v-if="pedido.endereco">
                       <b>Endereço:</b> {{ pedido.endereco.logradouro }}, {{ pedido.endereco.numero }}, {{ pedido.endereco.bairro }}, {{ pedido.endereco.cidade }}, CEP:  {{ pedido.endereco.cep }} - {{ pedido.endereco.estado }}
                    </v-flex>
                    </template>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                    <template v-if="pedido.itens_pedido && pedido.itens_pedido.length > 0">
                       <v-flex xs12 class="mb-2">
                        <h3 class="text-xs-center">Itens do pedido</h3>
                      </v-flex>
                      <v-flex xs12 v-if="pedido.itens_pedido">
                        <v-list three-line>
                          <v-list-tile v-for="(item, index) in pedido.itens_pedido" :key="index">
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ item.item.preco | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                              <v-list-tile-sub-title>{{ item.quantidade }} unidade(s)</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-content>
                              <v-list-tile-sub-title>{{ (Number(item.item.preco) * item.quantidade) | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </template>
                    <template v-if="pedido.assinatura">
                       <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12 class="mb-2">
                        <h3 class="text-xs-center">Assinatura</h3>
                      </v-flex>
                      <v-flex xs6>
                        <b>Valor</b> {{ pedido.assinatura.plano.valor | currency({ fractionCount: 2 }) }}
                      </v-flex>
                      <v-flex xs6>
                        <b>Status</b> {{ pedido.assinatura.status ? 'Paga' : 'Inativa' }}
                      </v-flex>
                      <v-flex xs6 v-if="pedido.assinatura.data_encerramento">
                        <b>Data de encerramento</b> {{ pedido.assinatura.data_encerramento | formatDate('DD/MM/YYYY') }}
                      </v-flex>
                      <v-flex xs6>
                        <b>Descrição</b> {{ pedido.assinatura.plano.descricao }}
                      </v-flex>
                    </template>
                    <v-flex xs12 v-if="pedido.total" class="text-xs-center ma-2">
                       <h3>Valor total: {{ pedido.total | currency({ fractionCount: 2 }) }}</h3>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions class="justify-space-around">
                <v-btn
                    @click="$emit('fechar')"
                    flat
                    block
                >
                    Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: ['pedido', 'active'],
  computed: {
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    frentista () {
      return this.$store.getters.frentista
    },
    empresa () {
      return this.$store.getters.empresa
    }
  },
  methods: {
    isNumber (value) {
      return typeof value === 'number' && !isNaN(value)
    },
    formatarValor (valor) {
      if (!valor) return 0
      if (this.isNumber(valor)) return valor
      return Number(valor.replaceAll('.', '').replace(',', '.'))
    }
  }
}
</script>
